// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__xn1OR","description":"PatientConsentPreview_description__apS_O"};